import { Variant } from '../typography/model';
import { ButtonGroupSize } from './model';

export const BUTTON_GROUP_LABEL_TYPOGRAPHY_VARIANT: Variant = 'body bold';
export const BUTTON_GROUP_LABEL_BORDER_WIDTH = 1;
export const BUTTON_GROUP_SIZE_DEFAULT: ButtonGroupSize = 'normal';
